"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getClientQueryParam = void 0;
var _getCurrentUrl = require("./getCurrentUrl");
var _isSSR = require("./isSSR");
const getClientQueryParam = queryParam => (0, _isSSR.isSSR)() ? null : (0, _getCurrentUrl.getCurrentUrl)().searchParams.get(queryParam);
exports.getClientQueryParam = getClientQueryParam;
